module.exports = __webpack_public_path__ + "img/jpg.f96f03ae.png";